import React from 'react';
import { Box } from 'theme-ui';

type Props = {
  title?: string;
  maxW: number;
}
const Section: React.FC<Props> = ({ title, maxW, children }) => {
  return (
    <>
      {title && (
        <Box sx={{ borderBottom: '1px solid #d9d9d9', my: '8px', fontSize: '12px', fontWeight: 500, color: '#717171' }}>
          {title}
        </Box>
      )}
      <Box sx={{ maxWidth: [null, '75%', maxW] }}>
        {children}
      </Box>
    </>
  );
};

export default Section;
